import { VerificationServiceDetailsState } from "@idw-types/state/verification-service-details-state";
import { getVerificationServiceDetailsState } from "@redux/selectors/root-selectors";
import { createSelector } from "reselect";

export const getVerificationServiceDetailsDataState = createSelector(getVerificationServiceDetailsState, (state: VerificationServiceDetailsState) => {
	return {
        isLoadingVerificationServiceDetails: state.verificationServiceDetails.isLoading,
        verificationServiceDetails: state.verificationServiceDetails.verificationServiceDetails
    }
});